import { Injectable } from '@angular/core';

import { EditLessonPlanComponent } from '../lessonPlans/editLessonPlan/editLessonPlan.component';

@Injectable()
export class PreventUnsavedLesson {
    canDeactivate(component: EditLessonPlanComponent) {
        if (component.form.dirty && !component.submitted) {
            return confirm('Are you sure you want to continue?  Any unsaved changes will be lost');
        }
        return true;
    }
}